import { render, staticRenderFns } from "./searchDataByStudent.vue?vue&type=template&id=6c97b0fc&scoped=true"
import script from "./searchDataByStudent.vue?vue&type=script&lang=js"
export * from "./searchDataByStudent.vue?vue&type=script&lang=js"
import style0 from "./searchDataByStudent.vue?vue&type=style&index=0&id=6c97b0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97b0fc",
  null
  
)

export default component.exports